import { activeSiteConfig } from "@config/site/site-config";

export const isMarketWithLoyalty = activeSiteConfig?.isMarketWithLoyalty ?? false;
export const hasTryAndBuy = activeSiteConfig?.hasTryAndBuy ?? false;
export const hasExtendedNewsletterForm = activeSiteConfig?.hasExtendedNewsletterForm ?? false;
